import { useContext } from "react";
import { CrehanaI18nContext } from "./Context.js";
import { validateIsConfig } from "./utils.js";
function useTranslation(namespace) {
    const context = useContext(CrehanaI18nContext);
    const t = (key, defaultValueOrConfig, config)=>{
        if ('string' == typeof defaultValueOrConfig) {
            const conf = validateIsConfig(config) ? config : void 0;
            return context.t(key, {
                namespace,
                defaultValue: defaultValueOrConfig,
                ...conf
            });
        }
        const conf = validateIsConfig(defaultValueOrConfig) ? defaultValueOrConfig : void 0;
        return context.t(key, {
            namespace,
            ...conf
        });
    };
    const addResourceBundle = (bundle, options)=>{
        if ('developmet' === process.env.NODE_ENV) {
            if (options) console.warn('addResourceBundle no longer receives an options paramenter');
        }
        return context.addResourceBundle(bundle);
    };
    return {
        t,
        addResourceBundle,
        languageKey: context.languageCode,
        languageCode: context.languageCode,
        countryCode: context.countryCode,
        countryPrefix: context.countryCode
    };
}
export { useTranslation };
